/* eslint-disable max-len */
import RestService from '../services/rest';

async function getBranchManager({ limit, skip, search = '', order = '', field = '' }) {
  let branchManagerUrl = 'panel/branchManager';

  if (limit) {
    branchManagerUrl += `?limit=${limit}&skip=${skip}`;  
  }

  if (search) {
    branchManagerUrl += `&search=${search}`;
  }

  if (order) {
    branchManagerUrl += `&order=${order}`;
  }

  if (field) {
    branchManagerUrl += `&field=${field}`;
  }

  return RestService.getAuthenticated(branchManagerUrl);
}

async function updateBranchManager(updatedFields) {
  return RestService.putAuthenticated('panel/branchManager/update', updatedFields);
}

async function createBranchManager(branchManager) {
  return RestService.postAuthenticated('panel/branchManager/create', branchManager);
}

async function deleteBranchManager(id) {
  return RestService.deleteAuthenticated(`panel/branchManager/delete/${id}`);
}

async function getBranchManagersReportCsv() {
  const response = await RestService.getAuthenticated(
    "panel/branchManager/report/csv",
    {
      responseType: "blob",
    }
  );
  const url = window.URL.createObjectURL(new Blob(["\ufeff", response]));
  const link = document.createElement("a");
  link.href = url;
  const filePath = "branch-managers-export.csv";
  link.setAttribute("download", filePath);
  document.body.appendChild(link);
  link.click();
}


export default {
  getBranchManager,
  deleteBranchManager,
  updateBranchManager,
  createBranchManager,
  getBranchManagersReportCsv,
};
